import React from "react";
import { useSearchParams } from "react-router-dom";
import PayrollDash from "./Payroll/PayrollDash";
import "./Admin.css";
import Employees from "./Employee/Employees";
import Payroll from "./Payroll/Payroll";
import AdminDashboard from "./AdminDashboard";
import MenuCMS from "./MenuCMS/MenuCMS";
import GiftcardAll from "./Giftcard/GiftcardAll";

function DBAdmin() {
  const [searchParams, setSearchParams] = useSearchParams();
  const body = searchParams.get("body") || "";
  const studioParam = searchParams.get("studio");
  const studioContext = ["full", "takeout", "cms"].includes(studioParam) ? studioParam : "full";
  const updateStudioContext = (context) => setSearchParams((current) => {
    const next = new URLSearchParams(current);
    if (context) next.set("studio", context);
    else next.delete("studio");
    return next;
  }, { replace: true });

  const renderBody = () => {
    switch (body) {
      case "payroll":
        return <PayrollDash />;
      case "payroll-editor":
        return <Payroll />;
      case "employees":
        return <Employees />;
      case "menu-cms":
        return <MenuCMS
          startInStudio={!!studioParam && ["full", "takeout", "cms"].includes(studioParam)}
          initialStudioContext={studioContext}
          onStudioContextChange={updateStudioContext}
          onExitStudio={() => updateStudioContext(null)}
        />;
      case "menu-studio":
        return <MenuCMS startInStudio initialStudioContext={studioContext} onStudioContextChange={updateStudioContext} onExitStudio={() => {
          const next = new URLSearchParams(searchParams);
          next.delete("body");
          next.delete("studio");
          setSearchParams(next);
        }} />;
      case "giftcards":
        return <GiftcardAll />;
      default:
        return "";
    }
  };

  return (
    <>
      <div className="dbadmin">{body ? renderBody() : <AdminDashboard />}</div>
    </>
  );
}

export default DBAdmin;
